import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { getHeaders } from './utils';
/**
 * Fetch with timeout wrapper
 * @param url - The URL to fetch
 * @param options - Fetch options
 * @param timeout - Timeout in milliseconds (default 6000ms = 6s)
 * @returns Promise that rejects on timeout
 */
// @note cancel the request

const fetchWithTimeout = async (url, options = {}, timeout = 6000) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);

  try {
    const response = await fetch(url, _objectSpread(_objectSpread({}, options), {}, {
      signal: controller.signal
    }));
    clearTimeout(timeoutId);
    return response;
  } catch (error) {
    clearTimeout(timeoutId);

    if (error.name === 'AbortError') {
      throw new Error('Request timeout - please try again');
    }

    throw error;
  }
};

export const getHCPCSdiagsearch = async (keycloak, agency, searchstring) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak === null || keycloak === void 0 ? void 0 : keycloak.token}`);
  headers.set('Accept-Profile', 'pimreader');
  let URL = `${process.env.REACT_APP_AUTH_PROXY_URL}`;
  URL += `/api/query/rpc/diagsearch?agency=${agency}`;
  URL += `&p_searchstring=${searchstring}`;

  try {
    const response = await fetchWithTimeout(URL, {
      headers,
      credentials: 'same-origin'
    }, 6000 // 6 seconds timeout
    ); // Check if response is ok (status 200-299)

    if (!response.ok) {
      if (response.status === 504) {
        throw new Error('Gateway timeout - server took too long to respond');
      }

      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const json = await response.json();
    return json;
  } catch (error) {
    console.error('Error fetching HCPCS diagnosis:', error); // Return a structured error response that your UI can handle

    return {
      error: true,
      message: error.message || 'Failed to fetch diagnosis codes',
      hint: 'timeout'
    };
  }
};
export const getHCPCSdiagallowed = async (keycloak, agency, patientnumber, patientid, roleshortname, visitdatetime) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak === null || keycloak === void 0 ? void 0 : keycloak.token}`);
  headers.set('Accept-Profile', 'pimreader');
  let URL = `${process.env.REACT_APP_AUTH_PROXY_URL}`;
  URL += `/api/query/rpc/gethcpcsdiagallowed?agency=${agency}`;
  URL += `&p_patientnumber=${patientnumber}`;
  URL += `&p_patient_id=${patientid}`;
  URL += `&p_roleshortname=${roleshortname}`;
  URL += `&p_visitdatetime=${visitdatetime}`;
  const hcpcs = await fetch(URL, {
    headers,
    credentials: 'same-origin'
  });
  const json = await hcpcs.json();
  return json;
};
/**
 * Rebuild the ICD count-map payload from icdCodeNames (UI source of truth).
 * Prefer this over context icdCodes — they can diverge when reducers mutate
 * nested objects in place.
 */

export const icdCodeNamesToMap = icdCodeNames => Object.keys(icdCodeNames).reduce((acc, key) => {
  acc[key] = (icdCodeNames[key] || []).reduce((codes, name) => {
    codes[name] = 1;
    return codes;
  }, {});
  return acc;
}, {});
/**
 * Build HCPCS
 * @note to be done when closing the visit at the moment
 */

export const buildHCPCS = (hcpcsCodeMap, hcpcsDuration, icdCodeMap, facilityId, facilityType) => {
  /**
   * @note hcpcsCodeMap may have more keys than icdCodeMap not the opposite
   */
  if (hcpcsCodeMap && Object.keys(hcpcsCodeMap).length) {
    const newMap = Object.entries(hcpcsCodeMap).reduce((seed, val) => {
      const key = val[0];
      const duration = hcpcsDuration && hcpcsDuration[key];
      const hcpcscodes = val[1];
      const parentCode = hcpcscodes.length && hcpcscodes[0];

      if (icdCodeMap && icdCodeMap[key]) {
        if (Object.keys(icdCodeMap[key]).length) {
          seed[key] = {
            hcpcs: hcpcscodes,
            icd: Object.keys(icdCodeMap[key]),
            key,
            duration,
            parentCode
          };
        } else {
          seed[key] = {
            hcpcs: hcpcscodes,
            key,
            duration,
            parentCode
          };
        }
      } else {
        seed[key] = {
          hcpcs: hcpcscodes,
          key,
          duration,
          parentCode
        };
      }

      return seed;
    }, {});
    const mapvalues = Object.values(newMap);
    const payload = mapvalues.reduce((seed, val) => {
      const icdCodes = val.icd && val.icd.length ? val.icd : [];
      val.hcpcs.forEach(code => {
        const dto = {
          hcpcsCode: code,
          hcpcsDiagnoses: icdCodes,
          rate: '',
          modifier: '',
          facilityId,
          facilityType,
          duration: val.duration,
          key: val.key,
          parentCode: val.parentCode
        };
        seed.push(dto);
      });
      return seed;
    }, []);
    return payload;
  }

  return null;
};
export const getHCPCScode = (hcpcsDuration, hcpcsRules, hcpcsChoice) => {
  if (hcpcsRules && hcpcsDuration) {
    const {
      addTime
    } = hcpcsChoice;
    const hcpcsMins = Object.keys(hcpcsRules);
    let uiCode = null;
    let hcpcsCode = []; // repeat of rule in HCPCSDuration

    const minDuration = Number(hcpcsMins[0]);

    if (hcpcsDuration >= minDuration) {
      const maxDuration = Number(hcpcsMins[hcpcsMins.length - 1]); // case 1 - above max duration

      if (hcpcsDuration >= maxDuration) {
        if (hcpcsChoice.noAddTime) {
          const code = hcpcsRules[maxDuration];
          uiCode = `${code}`;
          hcpcsCode = [`${code}`];
        } else {
          // step 1 : assemble first string
          const secondtoLastCode = hcpcsMins[hcpcsMins.length - 2];
          const firstCode = hcpcsRules[secondtoLastCode];
          const repeatCode = hcpcsRules[maxDuration]; // step 2 : determine how many block of addTime min above the max one

          const aboveTime = Math.floor((hcpcsDuration - maxDuration) / addTime);
          uiCode = `${firstCode} + ${repeatCode} (${aboveTime + 1} @ ${addTime} minutes each)`;
          const repeatCodeArr = Array(aboveTime + 1).fill(repeatCode);
          hcpcsCode = [`${firstCode}`, ...repeatCodeArr];
        }
      } else {
        // case 2 - below max duration
        const indexMin = hcpcsMins.findIndex(x => hcpcsDuration < Number(x));
        const targetMinIndex = indexMin === 0 ? indexMin : indexMin - 1;
        const targetMin = hcpcsMins[targetMinIndex];
        uiCode = targetMin && hcpcsRules[targetMin];
        hcpcsCode = [`${uiCode}`];
      }
    }

    return {
      uiCode,
      hcpcsCode
    };
  }

  return null;
};
export const hasDuplicates = array => new Set(array).size !== array.length;
export const addDuration = arr => {
  if (arr) return arr.reduce((seed, i) => Number(seed) + Number(i), 0);
  return 0;
}; // not used

export const canEditHCPCS = data => {
  const hasHCPCS = data.physicianservices && JSON.parse(data.physicianservices);
  const hasNoHCPCS = !data.physicianservices;
  const isHCPCSeditable = hasHCPCS ? hasHCPCS[0].duration : false;
  const canEdit = hasNoHCPCS || isHCPCSeditable;
  return canEdit;
};